import { render, staticRenderFns } from "./healthy.vue?vue&type=template&id=506acfeb&scoped=true"
import script from "./healthy.vue?vue&type=script&lang=js"
export * from "./healthy.vue?vue&type=script&lang=js"
import style0 from "./healthy.vue?vue&type=style&index=0&id=506acfeb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506acfeb",
  null
  
)

export default component.exports